import { render } from "./ViewManifestPage.vue?vue&type=template&id=78a1c2af&ts=true"
import script from "./ViewManifestPage.vue?vue&type=script&lang=ts"
export * from "./ViewManifestPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__